import { connect } from "react-redux";
import get from "lodash/get";

import { setRouteSpeedColor as onSetRouteSpeedColor } from "./../../actions/routeSpeedColorActions";

const mapStateToProps = (state) => ({
  dataState: state.routeSpeedColor.dataState,
  routeSpeedColorKey: get(state, ["routeSpeedColor", "routeSpeedColorKey"], new Date()),
  routeSpeedColor: get(state, ["routeSpeedColor", "routeSpeedColor"], null),
});

const mapDispatchToProps = { onSetRouteSpeedColor };

const withRouteSpeedColor = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withRouteSpeedColor };
